export default "/_next/static/images/f18fef97f73fb03bae97e980cf3b56f7.jpg";